/**
 * Component observer
 */

import Vue from 'vue'

Vue.component('front-video', require('../components/frontpage/FrontVideo.vue').default)
Vue.component('front-promos', require('../components/frontpage/FrontPromos.vue').default)
Vue.component('front-categories', require('../components/frontpage/FrontCategories.vue').default)
Vue.component('front-advantages', require('../components/frontpage/FrontAdvantages.vue').default)